<div fxLayout="column" fxLayoutAlign="start center">
  <div
    class="item mat-elevation-z3"
    fxLayoutAlign="center center"
    [matTooltipDisabled]="!desc"
    [matTooltip]="desc ?? '' | translate"
    matTooltipClass="tooltip"
    >
    @if (!iconSet) {
      <mat-icon class="gradient-icon">{{ icon }}</mat-icon>
    }
    @if (!!iconSet) {
      <mat-icon class="gradient-icon fa-icon"
        [fontSet]="iconSet"
        [fontIcon]="icon"
       />
    }
  </div>
  <p class="mat-caption text-align-center m-t-1">{{ title | translate }}</p>
</div>
